import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConfirmPopUp from '../../../../../shared/ConfirmPopUp/ConfirmPopUp';

import {
  deletePolygonConfirmation,
  deletePolygonIncludedInRuleConfirmation
} from 'common/utils/constants';
import { doAlertRulesGetShortInfo } from 'redux/Alerts/actions';

const PolygonDeletion = (props) => {
  const { deviceGroupId } = props;

  const dispatch = useDispatch();
  const polygonList = useSelector((store) => store.ui.devicesPage.polygons);

  const [confirmPopupInfo, setConfirmPopupInfo] = useState({ isIncludedRule: false, isShow: false, data: {} });

  useEffect(() => {
    const { _id: polygonId } = polygonList.find((polygon) => polygon.deviceGroupId === deviceGroupId);

    dispatch(doAlertRulesGetShortInfo(polygonId, (result) => {
      const isIncludedRule = result.length > 0;
      setConfirmPopupInfo(prevState => ({
        ...prevState,
        isIncludedRule,
        isShow: true,
        data: {
          title: isIncludedRule ? deletePolygonIncludedInRuleConfirmation.title : deletePolygonConfirmation.title,
          confirmText: isIncludedRule ? deletePolygonConfirmation.confirmText : deletePolygonIncludedInRuleConfirmation.confirmText,
          cancelText: isIncludedRule ? deletePolygonConfirmation.cancelText : deletePolygonIncludedInRuleConfirmation.cancelText
        }
      }));
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      {confirmPopupInfo.isShow && (
        <ConfirmPopUp
          {...confirmPopupInfo.data}
          onCancel={props.onCancel}
          onConfirm={props.onConfirm}
        />
      )}
    </>
  )
};

export default PolygonDeletion;